import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IApiRequest } from '@core/interfaces/api-request';
import { ApiService } from '@core/services/api.service';
import { ModalUtilsService } from '@core/services/modal-utils.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { NoPaymentMethodDialogComponent } from '@shared/components/no-payment-method-dialog/no-payment-method-dialog.component';
import { ToastService } from '@shared/components/toast/toasts.service';
import { LanguageService } from '@shared/services/language.service';
import { Observable, filter, map } from 'rxjs';
import { EnumBidResult } from 'src/app/article/enums/bid-result.enum';
import { IBidResponse } from 'src/app/article/interfaces/bid-response.interface';
import { Article } from 'src/app/articles-manager/interfaces/auction.interface';

@Component({
  selector: 'app-direct-offer-dialog',
  templateUrl: './direct-offer-dialog.component.html',
  styleUrls: ['./direct-offer-dialog.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, TranslatePipe, FormsModule, NgClass],
})
export class DirectOfferDialogComponent implements OnInit {
  @Input() isMemorabid: boolean = true;
  @Input() idAuction: number;
  @Input() idUserWinner: number;
  @Input() winnerUsername: string;
  @Input() entitySellerName: string;
  @Input() sportIds: string;
  @Input() competitionIds: string;
  @Input() teamIds: string;
  article = model<Article>();

  minPriceForOffer: number = 0;
  offeredPrice: number = 0;

  showErrorString = '';
  auctionPhoto: string = '/assets/img/not-found.png?w=110';
  acceptTermsCondition: boolean = false;

  title = computed(() => {
    return this.article().articleInfoList.find(
      (articleInfo) =>
        articleInfo.languageCode ==
        this.languageService.userSelectedLanguage.code
    )?.title;
  });

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private toastService: ToastService,
    private languageService: LanguageService,
    private _api: ApiService,
    private modalUtils: ModalUtilsService
  ) {}

  ngOnInit(): void {
    this.apiService
      .request<number>(
        ApiServiceHolder.auction.getMinPriceForOffer(this.idAuction)
      )
      .subscribe((dataR) => {
        this.minPriceForOffer = dataR;
        this.offeredPrice = this.minPriceForOffer;
      });

    if (
      this.article().articlePhotoList &&
      this.article().articlePhotoList.length > 0
    ) {
      for (var i = 0; i < this.article().articlePhotoList.length; i++) {
        if (this.article().articlePhotoList[i].isMainPhoto == true) {
          this.auctionPhoto = this.article().articlePhotoList[i].fullPath;
        }
      }
    }
  }

  makeDirectOffer() {
    this.filterNoPaymentApiResponse(
      ApiServiceHolder.auction.canmakebid(this.idAuction)
    ).subscribe((canMakeBidResponse) => {
      if (canMakeBidResponse.bidResult == EnumBidResult.Success) {
        if (this.acceptTermsCondition == false) {
          this.showErrorString = 'IDS_MUST_ACCEPT_TERMS_CONDITIONS';
        } else {
          if (this.offeredPrice > 100000) {
            this.showErrorString = 'IDS_LESS_ONE_HUNDRED_THOUSAND';
          } else {
            if (this.idUserWinner != null) {
              if (this.offeredPrice >= this.minPriceForOffer) {
                this.makeOffer();
              } else {
                this.showErrorString = 'IDS_LESS_WINNER_PRICE';
              }
            } else {
              if (this.offeredPrice >= this.minPriceForOffer) {
                this.makeOffer();
              } else {
                this.showErrorString = 'IDS_LESS_RESERVE_PRICE';
              }
            }
          }
        }
      } else {
        throw new Error('Server error on bid');
      }
    });
  }

  goToPage(route) {
    window.open(window.location.origin + route, '_blank');
  }

  private makeOffer() {
    this.apiService
      .request(
        ApiServiceHolder.message.makeOffer({
          idAuction: this.idAuction,
          offeredPrice: this.offeredPrice,
          messageContent: '',
          languageCode: this.languageService.userSelectedLanguage
            ? this.languageService.userSelectedLanguage.code
            : 'it',
        })
      )
      .subscribe(() => {
        this.toastService.show('IDS_MESSAGE_SENT', {
          classname: 'bg-success text-light',
        });
        this.activeModal.close(0);
      });
  }

  private filterNoPaymentApiResponse(
    apiRequest: IApiRequest
  ): Observable<IBidResponse> {
    return this._api.request<IBidResponse>(apiRequest).pipe(
      map((result) => {
        if (result.bidResult == EnumBidResult.NoPaymentMethod) {
          let ref = this.modalUtils.openModal(NoPaymentMethodDialogComponent, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
          });
          ref.result.then(
            () => {
              location.replace(result.stripeCheckoutSessionUrl);
            },
            () => {
              /* do nothing on close click */
            }
          );
        }

        return result;
      }),
      filter((result) => result.bidResult !== EnumBidResult.NoPaymentMethod)
    );
  }
}
